import React from "react";
import { Home, Building2, ClipboardCheck, MapPin } from "lucide-react";

export default function TrustBar() {
  const items = [
    {
      icon: Home,
      label: "Residential & Commercial"
    },
    {
      icon: ClipboardCheck,
      label: "Quality Concrete Work"
    },
    {
      icon: Building2,
      label: "Free Estimates"
    },
    {
      icon: MapPin,
      label: "Local Service"
    }
  ];

  return (
    <section id="trust" className="border-y-2 border-[hsl(var(--accent))]/30 bg-[#003166]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="flex flex-col sm:flex-row items-center gap-3 text-center sm:text-left"
              >
                <div className="flex items-center justify-center w-12 h-12 bg-[hsl(var(--accent))]/10 rounded-sm border border-[hsl(var(--accent))]/20 flex-shrink-0">
                  <Icon size={24} className="text-[#194d32]" />
                </div>
                <span className="font-heading text-white text-base sm:text-lg tracking-wider leading-tight">
                  {item.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}